import instance from '@/utils/axios';

/**
 * 获取预案列表
 * @param {string} keyword - 关键字
 * @param {string} name - 预案名称
 * @param {1|2|3|4} level - 预案等级 1-一级 2-二级 3-三级 4-四级
 * @param {number} offset - 当前页码
 * @param {number} limit - 每页数量
 */
export function getPlanData(data) {
  return instance.post('/plan/planData', data);
}
